import { render, staticRenderFns } from "./DeviceManagementPlugin.vue?vue&type=template&id=6135ee9c&"
import script from "./DeviceManagementPlugin.vue?vue&type=script&lang=ts&"
export * from "./DeviceManagementPlugin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports